<section
  class="py-14 bg-cover bg-center bg-no-repeat bg-[url('/assets/images/type/for-sale.webp')] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="absolute inset-0 bg-black opacity-70 z-0"></div>
  <div class="container mx-auto z-10 relative">
    <div class="flex flex-col items-center text-center space-y-4">
      <div class="inline-block p-5 bg-red-100 rounded-full mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="size-6 md:size-10 lg:size-12 text-red-600"
          viewBox="0 0 24 24"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <path
              d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
            />
            <circle cx="12" cy="10" r="3" />
          </g>
        </svg>
      </div>
      <h1 class="text-3xl md:text-4xl font-bold tracking-tighter text-white">
        Tesla Locations
      </h1>
      <p class="text-xl text-white max-w-[700px]">
        Find or sell a Tesla in your state
      </p>

      <div class="w-full max-w-md mt-4">
        <div class="relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 size-6"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="m17 17l4 4M3 11a8 8 0 1 0 16 0a8 8 0 0 0-16 0"
            />
          </svg>
          <input
            type="search"
            [(ngModel)]="searchQuery"
            placeholder="Search by state..."
            class="pl-12 pr-3 py-3 w-full border rounded-lg bg-white"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-12 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <section class="container mx-auto">
    <!-- Tabs Navigation -->
    <div class="flex justify-center mb-8">
      <div
        class="grid w-full max-w-md grid-cols-2 bg-gray-50 p-1 rounded-lg border"
      >
        <button
          (click)="setActiveTab('buy')"
          class="text-base py-2.5 px-4 rounded-md transition-all duration-200 cursor-pointer"
          [class.bg-white]="activeTab === 'buy'"
          [class.shadow-sm]="activeTab === 'buy'"
          [class.text-gray-900]="activeTab === 'buy'"
          [class.text-gray-600]="activeTab !== 'buy'"
        >
          Buy a Tesla
        </button>
        <button
          (click)="setActiveTab('sell')"
          class="text-base py-2.5 px-4 rounded-md transition-all duration-200 cursor-pointer"
          [class.bg-white]="activeTab === 'sell'"
          [class.shadow-sm]="activeTab === 'sell'"
          [class.text-gray-900]="activeTab === 'sell'"
          [class.text-gray-600]="activeTab !== 'sell'"
        >
          Sell Your Tesla
        </button>
      </div>
    </div>
    <!-- Buy Tab Content -->
    <div *ngIf="activeTab === 'buy'" class="animate-in fade-in duration-200">
      <div class="bg-white rounded-lg border shadow-md">
        <div class="p-6">
          <h2 class="text-2xl text-center font-semibold text-gray-900">
            Used Tesla For Sale In:
          </h2>
          <p class="text-center text-gray-600 mt-2">
            Select a state to browse available Tesla vehicles
          </p>
        </div>
        <div class="p-6 lg:p-10 border-t">
          <ul
            class="grid gap-x-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-6 text-sm list-disc"
          >
            <li
              *ngFor="let state of filteredStates"
              routerLink="/location/{{
                state.toLowerCase()
              }}/used-tesla-for-sale"
              class="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline transition-all duration-300 flex items-center gap-2 text-xl"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-6 text-blue-600"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path
                      d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                    />
                    <circle cx="12" cy="10" r="3" />
                  </g>
                </svg>
              </span>
              <span>{{ state }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="activeTab === 'sell'" class="animate-in fade-in duration-200">
      <div class="bg-white rounded-lg border shadow-md">
        <div class="p-6">
          <h2 class="text-2xl text-center font-semibold text-gray-900">
            Sell Your Tesla
          </h2>
          <p class="text-center text-gray-600 mt-2">
            Choose your state to get started
          </p>
        </div>
        <div class="p-6 lg:p-10 border-t">
          <ul class="grid gap-x-10 grid-cols-3 gap-y-6 text-sm list-disc">
            <li
              *ngFor="let state of filteredStates"
              routerLink="/location/{{ state.toLowerCase() }}/sell-my-tesla"
              class="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline transition-all duration-300 flex items-center gap-2 text-lg 2xl:text-xl"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-6 text-blue-600"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path
                      d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                    />
                    <circle cx="12" cy="10" r="3" />
                  </g>
                </svg>
              </span>
              <span>{{ state }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</section>
